import apiRoutes from '../../../routes/admin_api_routes.json'
import { findRecordInApiResponse } from '../../util/api_response_utils'
import { handleApiError } from '../../util/parse_server_error'
import { setDestroyed, setFetched } from '../api/actions'

export function createContact(contact, successCallback) {
  return function (axios, dispatch) {
    const path = apiRoutes.admin_api_v1_contacts.path
    return axios()
      .post(path, contact)
      .then(
        (result) => {
          dispatch(setFetched('contacts', result.data.records))
          successCallback && successCallback()
          const contact = findRecordInApiResponse(result, 'contacts')
          return Promise.resolve(contact.handle)
        },
        (result) => {
          handleApiError({
            dispatch,
            result,
            path,
          })
          return Promise.reject(result)
        },
      )
  }
}

export function updateContact(contactId, data) {
  return function (axios, dispatch) {
    const path = apiRoutes.admin_api_v1_contact.path
    const url = path.replace(':id', contactId)
    return axios()
      .put(url, { contact: data })
      .then(
        (result) => {
          dispatch(setFetched('contacts', result.data.records))
          return Promise.resolve(result)
        },
        (result) => {
          handleApiError({
            dispatch,
            result,
            path,
          })
          return Promise.reject(result)
        },
      )
  }
}

export function destroyContact(contactId) {
  return function (axios, dispatch) {
    const path = apiRoutes.admin_api_v1_contact.path
    const url = path.replace(':id', contactId)
    return axios()
      .delete(url)
      .then(
        (result) => {
          dispatch(setDestroyed('contacts', contactId))
          return Promise.resolve(result)
        },
        (result) => {
          handleApiError({
            dispatch,
            result,
            path,
          })
          return Promise.reject(result)
        },
      )
  }
}

export function spamContactAction(handle, action, reason) {
  return function (axios, dispatch) {
    const url = '/spam/' + action
    return axios()
      .put(url, { handle, reason })
      .then(
        (result) => {
          dispatch(setFetched('contacts', result.data.records))
          return Promise.resolve(result)
        },
        (result) => {
          handleApiError({
            dispatch,
            result,
            path: url,
          })
          return Promise.reject(result)
        },
      )
  }
}
